import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ScheduleService} from "../../../schedule/services/schedule-service.service";

export class AgentShiftTimelineLogsCtrl implements IController {

  shift: any;

  private timeline;
  private filterConfig;
  private isMobile;

  constructor(private scheduleService: ScheduleService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $mdMedia, private moment) {
  }

  $onInit() {
    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: {
        dateStart: this.moment(this.moment().local().toISOString()).startOf('day').valueOf(),
        dateEnd: this.moment(this.moment().local().toISOString()).endOf('day').valueOf()
      }
    }

    this._getLogsTimeline();
  }

  $doCheck() {
    this.isMobile = !this.$mdMedia('gt-xs');
  }

  $onChanges(changes) {
    if (changes.shift && !changes.shift.isFirstChange()) {
      this.shift = changes.shift.currentValue;
      this._getLogsTimeline();
    }
  }

  onRangeChanged(range) {
    if (range &&
      (!_.isEqual(range.dateStart, this.filterConfig.range.dateStart) ||
        !_.isEqual(range.dateEnd, this.filterConfig.range.dateEnd))) {

      this.filterConfig.range = range;
      this._getLogsTimeline();
    }
  }

  private _getLogsTimeline() {
    if (this.shift) {
      this.scheduleService.getScheduleTimeline(
        this.shift.agentSchedule.id,
        _.get(this.filterConfig, 'range.dateStart'),
        _.get(this.filterConfig, 'range.dateEnd')
      )
        .then((timeline) => {
          this.timeline = timeline;
        })
    }
  }

}
angular
  .module('bringoz.admin.agents')
  .component('agentShiftTimelineLogs', {
    bindings: {
      shift: '<'
    },
    template: require('./agent-shift-timeline-logs.html').default,
    controller: AgentShiftTimelineLogsCtrl
  });
